module.exports = __webpack_public_path__ + "static/media/adjust-circle.73fdfe42.svg";